/**
 * The organization provider uses the literal `'admin'` as a sentinel for the
 * platform-admin "all organizations" view (see organization-provider.tsx), so
 * `currentOrganizationId` is not always an organization uuid. Any consumer
 * that feeds the value into a uuid-typed filter (Postgres 22P02 on the
 * sentinel) or a per-org realtime topic (RLS-denied join) must gate on this
 * instead of a bare truthiness check.
 *
 * Deliberately NOT full uuid-shape validation: `'admin'` is the only non-uuid
 * value the provider ever writes (real ids come from DB uuid rows), and shape
 * validation would silently reject the slug-style fixture ids ('org-1') used
 * across the test suites of every consumer.
 *
 * A pure module with no side-effecting imports so realtime hooks and other
 * lean consumers can depend on it without dragging in the Supabase client
 * (mirrors task-query-keys.ts).
 */
export function isQueryableOrganizationId(
  organizationId: string | undefined | null,
): organizationId is string {
  return !!organizationId && organizationId !== 'admin';
}
